import { useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import {
  Box,
  Tab,
  Tabs,
  Modal,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import React from "react";
import useTranslation from "../../hooks/traslation";
import { useLazyGetTaskDetailByIdQuery } from "../../services/users";
import { showError, showToast } from "../../constants/toasts";
import { Tasks } from "../../types/General";
import { BOOKING_STATUS, SKILLS, TASK_STATUS } from "../../utils/enums";
import moment from "moment";
import { useAddRefundMutation } from "../../services/refund";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {" "}
      {value === index && <>{children}</>}{" "}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const ManageOffers = () => {
  const navigate = useNavigate();
  const { id, statusType } = useParams();
  const translation = useTranslation();
  const [searchTerm, setSearchTerm] = useState("");
  const [valueTabs, setValueTabs] = React.useState(0);
  const [openEmployeeModal, setOpenEmployeeModal] = useState(false);
  const [employeeAmount, setEmployeeAmount] = useState("");
  const [freelancerAmount, setFreelancerAmount] = useState("");
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [taskDetail, setTaskDetail] = useState<Tasks | null>(null);
  const [getTaskDetailMethod] = useLazyGetTaskDetailByIdQuery();
  const [addRefund] = useAddRefundMutation();

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const handleEmployeeAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const employeeAmountNum = Number(value) || 0;
    const freelancerAmountNum = Number(freelancerAmount) || 0;
    const total = taskDetail?.total || 0;

    if (employeeAmountNum <= total) {
      setEmployeeAmount(value);
      if (employeeAmountNum + freelancerAmountNum > total) {
        setFreelancerAmount((total - employeeAmountNum).toString());
      }
    }
  };

  const handleFreelancerAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const freelancerAmountNum = Number(value) || 0;
    const employeeAmountNum = Number(employeeAmount) || 0;
    const total = taskDetail?.total || 0;

    if (freelancerAmountNum + employeeAmountNum <= total) {
      setFreelancerAmount(value);
    }
  };

  const handleEmployeePayment = async () => {
    if (!employeeAmount || !id) {
      showError("Please enter amount");
      return;
    }
    const amount = Number(employeeAmount);
    if (amount >= (taskDetail?.total || 0)) {
      showError(
        `Amount must be less than total amount (${taskDetail?.total} AED)`
      );
      return;
    }
    if (amount >= (taskDetail?.subTotal || 0)) {
      showError(
        `Amount must be less than sub amount (${taskDetail?.subTotal} AED)`
      );
      return;
    }
    setValueTabs(1);
  };

  const handleFreelancerPayment = async () => {
    if (!freelancerAmount || !id) {
      showError("Please enter amount");
      return;
    }
    const freelancerAmountNum = Number(freelancerAmount);
    const employeeAmountNum = Number(employeeAmount);
    const total = taskDetail?.total || 0;

    if (freelancerAmountNum + employeeAmountNum > total) {
      showError(
        `Total amount (${freelancerAmountNum + employeeAmountNum} AED) cannot exceed ${total} AED`
      );
      return;
    }
    setOpenConfirmationDialog(true);
  };

  const handleConfirmPayment = async () => {
    if (!id) {
      showError("Invalid booking ID");
      return;
    }
    const body = {
      data: {
        bookingId: id,
        refundAmount: Number(employeeAmount),
        walletAmount: Number(freelancerAmount),
      },
    };
    try {
      const response = await addRefund(body).unwrap();
      if (response?.statusCode === 200) {
        showToast("Payment processed successfully");
        setOpenConfirmationDialog(false);
        navigate("/manage-dispute-refunds");
      }
    } catch (error: any) {
      console.error("Payment Error:", error);
      showError(error?.data?.message || "Failed to process payment");
    }
  };
  const handleCloseConfirmation = () => {
    setOpenConfirmationDialog(false);
  };
  const getTaskDetail = async (id: string) => {
    setLoading(true);
    try {
      const response = await getTaskDetailMethod({ id }).unwrap();
      setLoading(false);
      if (response?.statusCode === 200) {
        setTaskDetail(response?.data || null);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };
  console.log(taskDetail, "DATA");

  useEffect(() => {
    if (id) {
      getTaskDetail(id);
    }
  }, [id]);
  const formatStatus = (status: number) => {
    const statusKey = Object.keys(BOOKING_STATUS).find(
      (key) => BOOKING_STATUS[key as keyof typeof BOOKING_STATUS] === status
    );
    if (!statusKey) return "-";
    return statusKey
      .replace(/_/g, " ")
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };
  return (
    <MainContainer>
      {" "}
      <div className="main_title">
        {" "}
        <h1>{translation.main.refundDetail}</h1>{" "}
        <p>
          {" "}
          <span onClick={() => navigate("/dashboard")}>
            {" "}
            {translation.dashboard.dashboard}{" "}
          </span>{" "}
          -{" "}
          <span onClick={() => navigate("/manage-dispute-refunds")}>
            {" "}
            {translation.main.Refunds}{" "}
          </span>{" "}
          - {translation.main.Details}{" "}
        </p>{" "}
      </div>{" "}
      <div className="cards view_page">
        {" "}
        <div className="section_title">
          {" "}
          <h2>{translation.main.refundReqDetail}</h2>{" "}
        </div>{" "}
        <div className="gap_p">
          {" "}
          {/* <div className="vew_img no_radius w_100"> <h6>{translation.main.Image}</h6> <figure> <img alt="user" src={taskDetail?.media?.[0] || "/static/images/placeholder.png"} /> </figure> </div> */}{" "}
          <div className="w_33">
            {" "}
            <h6>{translation.globals.name}</h6>{" "}
            <p>{taskDetail?.serviceNames?.[0] || "-"}</p>{" "}
          </div>{" "}
          <div className="w_33">
            {" "}
            <h6>{translation.main.Category}</h6>{" "}
            <p>{taskDetail?.category?.name || "-"}</p>{" "}
          </div>{" "}
          <div className="w_33">
            {" "}
            <h6>{translation.main.subService}</h6>{" "}
            <p>{taskDetail?.subCategory?.name || "-"}</p>{" "}
          </div>{" "}
          <div className="w_33">
            {" "}
            <h6>{translation.main.adOns}</h6>{" "}
            <p>{taskDetail?.serviceNames?.join(", ") || "-"}</p>{" "}
          </div>{" "}
          {/* <div className="w_33">
            {" "}
            <h6>{translation.main.dateTime}</h6>{" "}
            <p>
              {" "}
              {taskDetail?.date
                ? moment(taskDetail.date).format("DD MMM YYYY, hh:mm A")
                : "-"}{" "}
            </p>{" "}
          </div>{" "} */}
          <div className="w_33">
            {" "}
            <h6>Duration</h6>{" "}
            <p>
              {" "}
              {taskDetail?.startTime && taskDetail?.endTime
                ? `${moment(taskDetail.startTime).format("hh:mm A")} - ${moment(
                    taskDetail.endTime
                  ).format("hh:mm A")}`
                : "-"}{" "}
            </p>{" "}
          </div>{" "}
          <div className="w_33">
            {" "}
            <h6>Task Status</h6>{" "}
            <p className="c_primary">
              {" "}
              {taskDetail?.status !== undefined
                ? formatStatus(taskDetail.status)
                : "-"}{" "}
            </p>{" "}
          </div>{" "}
          <div className="w_33">
            {" "}
            <h6>Task Start Time</h6>{" "}
            <p>
              {" "}
              {taskDetail?.startedAt
                ? moment(taskDetail.startedAt).format("DD MMM YYYY, hh:mm A")
                : "-"}{" "}
            </p>{" "}
          </div>{" "}
          <div className="w_33">
            {" "}
            <h6>Task Cancel Time</h6>{" "}
            <p>
              {" "}
              {taskDetail?.cancelledAt
                ? moment(taskDetail.cancelledAt).format("DD MMM YYYY, hh:mm A")
                : "-"}{" "}
            </p>{" "}
          </div>{" "}
          <div className="w_33">
            {" "}
            <h6>Task Complete Time</h6>{" "}
            <p>
              {" "}
              {taskDetail?.completedAt
                ? moment(taskDetail.completedAt).format("DD MMM YYYY, hh:mm A")
                : "-"}{" "}
            </p>{" "}
          </div>{" "}
          <div className="w_100">
            {" "}
            <h6>Notes</h6> <p>{taskDetail?.notes || "-"}</p>{" "}
          </div>{" "}
          <div className="w_33">
            {" "}
            <h6>Skills</h6>{" "}
            <p>
              {" "}
              {taskDetail?.skills
                ?.map((skillId) =>
                  Object.keys(SKILLS).find(
                    (key) =>
                      SKILLS[key as keyof typeof SKILLS] === Number(skillId)
                  )
                )
                .join(", ") || "-"}{" "}
            </p>{" "}
          </div>{" "}
          <div className="w_33">
            {" "}
            <h6>Total Amount</h6>{" "}
            <p>{taskDetail?.total ? `${taskDetail.total} AED` : "-"}</p>{" "}
          </div>{" "}
          <div className="w_33">
            {" "}
            <h6>Sub Amount</h6>{" "}
            <p>{taskDetail?.subTotal ? `${taskDetail.subTotal} AED` : "-"}</p>{" "}
          </div>{" "}
        </div>{" "}
      </div>{" "}
      {Number(statusType) == 2 ? null : (
        <div className="cards">
          {" "}
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            {" "}
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              {" "}
              <Tab label="Pay to Employee" {...a11yProps(0)} />{" "}
              <Tab label="Pay to Freelancer" {...a11yProps(1)} />{" "}
            </Tabs>{" "}
          </Box>{" "}
          <CustomTabPanel value={valueTabs} index={0}>
            {" "}
            <div className="form">
              {" "}
              <div className="gap_p">
                {" "}
                <div className="control_group w_50">
                  {" "}
                  <label>Amount</label>{" "}
                  <TextField
                    placeholder="Enter Amount"
                    variant="outlined"
                    className="text_field"
                    fullWidth
                    hiddenLabel
                    type="number"
                    value={employeeAmount}
                    onChange={handleEmployeeAmountChange}
                    onPaste={(e) => {
                      e.preventDefault();
                      const pastedText = e.clipboardData.getData("text");
                      const numValue = Number(pastedText) || 0;
                      if (numValue <= (taskDetail?.total || 0)) {
                        setEmployeeAmount(pastedText);
                      }
                    }}
                    inputProps={{ min: 0, max: taskDetail?.total || 0 }}
                    required
                  />{" "}
                </div>{" "}
              </div>{" "}
              <div className="form_btn" style={{ marginTop: "20px" }}>
                {" "}
                <Button
                  variant="contained"
                  className="btn btn_primary"
                  size="small"
                  sx={{
                    minWidth: "60px",
                    maxWidth: "80px",
                    padding: "2px 8px",
                    fontSize: "0.75rem",
                    height: "28px",
                  }}
                  onClick={handleEmployeePayment}
                >
                  {" "}
                  Next{" "}
                </Button>{" "}
              </div>{" "}
            </div>{" "}
          </CustomTabPanel>{" "}
          <CustomTabPanel value={valueTabs} index={1}>
            {" "}
            <div className="form">
              {" "}
              <div className="gap_p">
                {" "}
                <div className="control_group w_50">
                  {" "}
                  <label>Amount</label>{" "}
                  <TextField
                    placeholder="Enter Amount"
                    variant="outlined"
                    className="text_field"
                    fullWidth
                    hiddenLabel
                    type="number"
                    value={freelancerAmount}
                    onChange={handleFreelancerAmountChange}
                    onPaste={(e) => {
                      e.preventDefault();
                      const pastedText = e.clipboardData.getData("text");
                      const numValue = Number(pastedText) || 0;
                      if (numValue <= (taskDetail?.total || 0)) {
                        setFreelancerAmount(pastedText);
                      }
                    }}
                    inputProps={{ min: 0, max: taskDetail?.total || 0 }}
                    required
                  />{" "}
                </div>{" "}
              </div>{" "}
              <div className="form_btn" style={{ marginTop: "20px" }}>
                {" "}
                <Button
                  variant="contained"
                  className="btn btn_primary"
                  size="small"
                  sx={{
                    minWidth: "60px",
                    maxWidth: "80px",
                    padding: "2px 8px",
                    fontSize: "0.75rem",
                    height: "28px",
                  }}
                  onClick={handleFreelancerPayment}
                >
                  {" "}
                  Submit{" "}
                </Button>{" "}
              </div>{" "}
            </div>{" "}
          </CustomTabPanel>{" "}
        </div>
      )}{" "}
      <Dialog
        open={openConfirmationDialog}
        onClose={handleCloseConfirmation}
        aria-labelledby="confirmation-dialog-title"
      >
        {" "}
        <DialogTitle id="confirmation-dialog-title">
          {" "}
          Confirm Payment{" "}
        </DialogTitle>{" "}
        <DialogContent>
          {" "}
          Are you sure you want to pay the freelancer{" "}
        </DialogContent>{" "}
        <DialogActions>
          {" "}
          <Button
            onClick={handleCloseConfirmation}
            style={{ color: "#BF2F17" }}
          >
            {" "}
            No{" "}
          </Button>{" "}
          <Button onClick={handleConfirmPayment} style={{ color: "#BF2F17" }}>
            {" "}
            Yes{" "}
          </Button>{" "}
        </DialogActions>{" "}
      </Dialog>{" "}
    </MainContainer>
  );
};
export default ManageOffers;
